import createIcon from '../../createIcon';

/**
 * @component @name PermPhoneMsg
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTUuNUMxOC43NSAxNS41IDE3LjU1IDE1LjMgMTYuNDMgMTQuOTNDMTYuMDggMTQuODIgMTUuNjkgMTQuOSAxNS40MSAxNS4xN0wxMy4yMSAxNy4zN0MxMC4zOCAxNS45MyA4LjA2IDEzLjYyIDYuNjIgMTAuNzlMOC44MiA4LjU4QzkuMSA4LjMxIDkuMTggNy45MiA5LjA3IDcuNTdDOC43IDYuNDUgOC41IDUuMjUgOC41IDRDOC41IDMuNDUgOC4wNSAzIDcuNSAzSDRDMy40NSAzIDMgMy40NSAzIDRDMyAxMy4zOSAxMC42MSAyMSAyMCAyMUMyMC41NSAyMSAyMSAyMC41NSAyMSAyMFYxNi41QzIxIDE1Ljk1IDIwLjU1IDE1LjUgMjAgMTUuNVpNMTIgM1YxM0wxNSAxMEgyMVYzSDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PermPhoneMsg = createIcon('PermPhoneMsg', [
  [
    'path',
    {
      d: 'M20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.08 14.82 15.69 14.9 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.58C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM12 3V13L15 10H21V3H12Z',
      key: 'hpzbyd',
    },
  ],
]);

export default PermPhoneMsg;
